import { useFormik } from 'formik';
import { initialValues } from './formData';
import { ParamWithNestedParent } from '../../../../../shared/types/param';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';

export const useSubtypeDPFilters = (
    onFilter?: (data: ParamWithNestedParent) => void
) => {
    const [halfs, setHalfs] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const onSubmit = (data: ParamWithNestedParent) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_HALF).then((params) =>
            setHalfs(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypes(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    return {
        formik,
        halfs,
        types,
    };
};
